import React from "react";
import { faLightbulbExclamationOn } from "@fortawesome/pro-regular-svg-icons/faLightbulbExclamationOn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { ReadMore, ReadMoreWithAnchor } from "../../Components/ReadMore";

import styles from "./AttentionBox.module.scss";
export interface AttentionBoxProps {
    message: JSX.Element | string;
    className?: string;
    variant?: "compareWarning" | "normalWarning";
    readMore?: boolean;
    maxHeight?: number;
}
export const AttentionBox: React.FC<AttentionBoxProps> = ({
    message,
    className,
    readMore,
    maxHeight,
    variant = "wideBottomMargin"
}) => {
    const messageBox = readMore ? (
        maxHeight == null ? (
            <ReadMoreWithAnchor>
                <div
                    style={{
                        display: "inline-block"
                    }}
                >
                    {message}
                </div>
            </ReadMoreWithAnchor>
        ) : (
            <ReadMore allowedHeight={maxHeight}>
                <div
                    style={{
                        display: "inline-block"
                    }}
                >
                    {message}
                </div>
            </ReadMore>
        )
    ) : (
        message
    );
    return (
        <div className={`${className ?? ""} ${styles.attentionBoxContainer} ${styles[variant] ?? ""}`}>
            {variant == null && (
                <div className={styles.warningIcon}>
                    <FontAwesomeIcon icon={faLightbulbExclamationOn} />
                </div>
            )}

            {variant === "normalWarning" && (
                <div className={styles.normalWarningIcon}>
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
            )}

            {variant === "compareWarning" ? (
                <>
                    <div className={styles.compareWarningIcon}>
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                    </div>
                </>
            ) : null}

            <div className={styles.message}>
                {variant === "normalWarning" && (
                    <span>
                        <strong
                            style={{
                                marginRight: "2px"
                            }}
                        >
                            Warning!
                        </strong>{" "}
                        {messageBox}
                    </span>
                )}

                {variant === "compareWarning" && (
                    <span>
                        <strong
                            style={{
                                marginRight: "2px"
                            }}
                        >
                            Warning! Compare with caution.
                        </strong>{" "}
                        {messageBox}
                    </span>
                )}

                {variant == null && <>{messageBox}</>}
            </div>
        </div>
    );
};
